import { Component, OnInit, Type } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InvoiceListComponent } from '@shared/components/invoice-list/invoice-list.component';
import { USER_ROLES } from '@shared/constant/shared.constant';
import { FinancialComponent } from '../financial/financial.component';
import { CustomInvoiceComponent } from '@shared/components/custom-invoice/custom-invoice.component';
import { TransactionComponent } from '../transaction/transaction.component';
import { DriverInvoiceListComponent } from '@shared/components/driver-invoice-list/driver-invoice-list.component';
import { InvoiceBookingComponent } from '@shared/components/invoice-booking/invoice-booking.component';
import { CommonFunctions } from '@shared/common-functions';
import { DatePipe } from '@angular/common';
import { MenuService } from '@core/services/menu.service';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-financial-tabs',
  templateUrl: './financial-tabs.component.html',
  styleUrls: ['./financial-tabs.component.scss']
})
export class FinancialTabsComponent implements OnInit {
  activeIndex = 0;
  role: string = '';
  id: string | null = null;
  roleRoute : any;
  formattedDate: string;
  bookingInvoicesTab : { label: string; component: Type<any>; id?: string  } | null = null;
  customInvoicesTab : { label: string, component: Type<any> } | null = null;
  isManageInvoiceHeader: boolean;
  
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router : Router,
    private readonly datePipe: DatePipe,
    private readonly menuService:MenuService,
    private readonly encryptStorage: EncryptionStorageService
  ) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      const tabValue = parseInt(params.get('tab') || '0', 10); // Default to 0 if 'tab' is null
      this.setActiveTab(tabValue);
    });
    this.role = this.encryptStorage.getItem('roleName') || '';
    this.id = this.encryptStorage.getItem('companyId');
    this.updateTabs();
    this.updateCustomTab();
    this.roleRoute = CommonFunctions.routeToBookingDetail(this.role);
    this.updateTime();
  }
  updateTabs() {
    const currentRoute = this.route.snapshot.routeConfig?.path || '';
    if (currentRoute.includes('financial')) {
      this.bookingInvoicesTab = { label: 'Bookings', component: this.role === USER_ROLES.SUPER_ADMIN ? FinancialComponent : TransactionComponent,id: this.id };
    } else if(this.isDriverOrGroupUser && currentRoute.includes('invoice'))  {
      this.isManageInvoiceHeader = true;
      this.bookingInvoicesTab = {label : 'Booking Invoices', component : InvoiceBookingComponent };
    }
    else if(this.isParkingManagerOrOwner && currentRoute.includes('invoice-list')){
      this.isManageInvoiceHeader = true;
      this.bookingInvoicesTab = {label : 'Booking Invoices', component : InvoiceBookingComponent };
    }
    else{
      this.bookingInvoicesTab = null;
    }
  }
  updateCustomTab() {
    const currentRoute = this.route.snapshot.routeConfig?.path || '';
    if (this.isParkingManagerOrOwner && currentRoute.includes('invoice-list')) {
      this.customInvoicesTab = { label: 'Custom Invoices', component: InvoiceListComponent };
    }
    else if(this.isDriverOrGroupUser && currentRoute.includes('invoice-list')  ){
      this.customInvoicesTab = {label : 'Custom Invoices' ,  component : DriverInvoiceListComponent};
    }
    else{
      this.customInvoicesTab = {label : 'Custom Invoices' ,  component : CustomInvoiceComponent};
    }
  }

  setActiveTab(index: number) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: index },
      queryParamsHandling: 'merge' // Preserve other query parameters
    });
    this.updateTime();
    this.activeIndex = index;
  }

  updateTime(): void {
    const currentDate = new Date();
    this.formattedDate = this.datePipe.transform(currentDate, 'MMM dd, yyyy - hh:mm a');
  }

  isTabActive(index: number): boolean {
    return this.activeIndex === index;
  }
  get isParkingManagerOrOwner(): boolean {
    return this.role === USER_ROLES.SUPER_ADMIN || this.role === USER_ROLES.PARKING_MANAGER || this.role === USER_ROLES.PARKING_OWNER;
  }
  get isDriverOrGroupUser(): boolean {
    return this.role === USER_ROLES.DRIVER || this.role === USER_ROLES.GROUP_USER;
  }

  get isFinancialRoute(): boolean {
    return this.route.snapshot.routeConfig?.path?.includes('financial') || false;
  }

  get hasShowPermission(): boolean {
    return  this.menuService.shortNameExists(JSON.parse(this.encryptStorage.getItem('menuData')), 85) || false;
  }

  navigateToCreateCustom() {
    const route = this.role === USER_ROLES.SUPER_ADMIN
      ? `/${this.roleRoute}/invoice/${this.id}`
      : `/${this.roleRoute}/invoice`;
    this.router.navigate([route]);
  }
}
